"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var _Site = require("../Site.config");
var useStyles = function useStyles(isMobileView, withSidebarMargin) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccFooterStyle = (0, _react.useMemo)(function () {
    var sidebarMargin = withSidebarMargin ? pxToRem(_Site.sidebarWidth) : 0;
    var ccFooter = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: pxToRem(14),
      boxSizing: 'border-box',
      justifyContent: 'space-between',
      backgroundColor: '#3d3c48',
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light,
      right: 0,
      bottom: 0,
      left: 0,
      position: isMobileView ? 'relative' : 'absolute',
      height: isMobileView ? pxToRem(500) : pxToRem(179),
      padding: isMobileView ? "".concat(pxToRem(50), " ").concat(pxToRem(32), " ").concat(pxToRem(70), " ").concat(pxToRem(32)) : "".concat(pxToRem(48), " ").concat(pxToRem(56)),
      margin: direction === 'rtl' ? "0 ".concat(sidebarMargin, " 0 0") : "0 0 0 ".concat(sidebarMargin),
      marginTop: isMobileView ? pxToRem(-60) : '',
      display: isMobileView ? 'block' : 'flex',
      textAlign: isMobileView ? 'center' : 'unset'
    });
    var ccFooterLogo = (0, _css.css)({
      opacity: 0.7,
      marginBottom: isMobileView ? pxToRem(30) : '',
      display: isMobileView ? 'flex' : '',
      justifyContent: isMobileView ? 'center' : '',
      alignItems: isMobileView ? 'center' : '',
      img: {
        width: pxToRem(isMobileView ? 100 : 130),
        height: 'auto'
      }
    });
    var ccFooterLink = {
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light
    };
    var ccFooterLinks = (0, _css.css)({
      height: pxToRem(96),
      flexDirection: 'column',
      justifyContent: 'space-between',
      textAlign: 'start',
      fontWeight: 400,
      display: isMobileView ? 'inline-flex' : 'flex',
      padding: isMobileView ? "0 ".concat(pxToRem(20)) : ''
    });
    var ccFooterContactLink = {
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.shade3
    };
    var ccFooterContactLinkSeparator = (0, _css.css)({
      display: 'inline-block',
      margin: "0 ".concat(pxToRem(4)),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light
    });
    var ccFooterRights = (0, _css.css)({
      margin: pxToRem(3),
      whiteSpace: 'nowrap'
    });
    var ccFooterVerticalLine = (0, _css.css)({
      width: '1px',
      height: pxToRem(30.31),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light,
      margin: "0 ".concat(pxToRem(20)),
      display: 'inline-block',
      opacity: 0.5
    });
    var ccFooterHorizontalLine = (0, _css.css)({
      height: pxToRem(35),
      borderBottom: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light),
      opacity: 0.5
    });
    var ccFooterSocials = (0, _css.css)({
      width: pxToRem(128),
      display: 'inline-flex',
      justifyContent: 'space-between',
      paddingTop: isMobileView ? pxToRem(30) : ''
    });
    var ccFooterInfo = (0, _css.css)({
      height: pxToRem(isMobileView ? 150 : 96),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      fontWeight: 400
    });
    var ccFooterAddress = (0, _css.css)({
      opacity: 0.7
    });
    return {
      ccFooter: ccFooter,
      ccFooterLogo: ccFooterLogo,
      ccFooterRights: ccFooterRights,
      ccFooterVerticalLine: ccFooterVerticalLine,
      ccFooterHorizontalLine: ccFooterHorizontalLine,
      ccFooterLinks: ccFooterLinks,
      ccFooterLink: ccFooterLink,
      ccFooterContactLink: ccFooterContactLink,
      ccFooterContactLinkSeparator: ccFooterContactLinkSeparator,
      ccFooterSocials: ccFooterSocials,
      ccFooterInfo: ccFooterInfo,
      ccFooterAddress: ccFooterAddress
    };
  }, [isMobileView, direction, fontFamily, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.shade3, pxToRem, withSidebarMargin]);
  return {
    'cc-Footer': ccFooterStyle.ccFooter,
    'cc-Footer__logo': ccFooterStyle.ccFooterLogo,
    'cc-Footer__rights': ccFooterStyle.ccFooterRights,
    'cc-Footer__vertical-line': ccFooterStyle.ccFooterVerticalLine,
    'cc-Footer__horizontal-line': ccFooterStyle.ccFooterHorizontalLine,
    'cc-Footer__links': ccFooterStyle.ccFooterLinks,
    'cc-Footer__link': ccFooterStyle.ccFooterLink,
    'cc-Footer__contact-link': ccFooterStyle.ccFooterContactLink,
    'cc-Footer__contact-link-separator': ccFooterStyle.ccFooterContactLinkSeparator,
    'cc-Footer__socials': ccFooterStyle.ccFooterSocials,
    'cc-Footer__info': ccFooterStyle.ccFooterInfo,
    'cc-Footer__address': ccFooterStyle.ccFooterAddress
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;